// extracted by mini-css-extract-plugin
export var infoMessage = "info-message_ozuCE3WMQx2xmGygrAVg";
export var mainHeader = "main-header_vmJxk6wtO7lLOSaNJI8r";
export var pagination = "pagination_nFGrWqTC8s5a766IYtLi";